import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import { RDCCase } from "../../rdcapi/entities";
import { getCaseNumber, getCaseStatus, getCaseType, getClosureDate, getRegistrationDate } from "./index";

export interface RDCCaseProps {
	items: RDCCase[];
}

class RDCCaseListView extends Component<RDCCaseProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { items } = this.props;

		return <ListDataView
			items={ items }
			title={ "" }
			renderListHeader={ () => {
				return <RenderHeader/>;
			} }
			renderListItem={ ( item: RDCCase ) => {
				return <RenderListItem
					key={ item.caseNo }
					item={ item }/>;
			} }/>;

	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: true,
				lengthChange: false
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.case_number }</th>
		<th>{ Strings.case_status }</th>
		<th>{ Strings.case_type }</th>
		<th>{ Strings.registration_date }</th>
		<th>{ Strings.closure_date }</th>
	</tr>;
}

function RenderListItem( props: { item: RDCCase } ) {
	const { item } = props;
	return <tr>
		<td data-label={ Strings.case_number }>{ getCaseNumber( item ) }</td>
		<td data-label={ Strings.case_status }>{ getCaseStatus( item ) }</td>
		<td data-label={ Strings.case_type }>{ getCaseType( item ) }</td>
		<td data-label={ Strings.registration_date }>{ getRegistrationDate( item ) }</td>
		<td data-label={ Strings.closure_date }>{ getClosureDate( item ) }</td>
	</tr>;
}

export default RDCCaseListView;
